<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioPlanoSaude" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-12 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioPlanoSaude.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioPlanoSaude.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-2 col-md-2 col-sm-6 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="ativo" formControlName="ativo">Ativo</mat-checkbox>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-2 col-md-2 col-sm-6 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="interno" formControlName="interno">Interno</mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-6">
                            <mat-label>Per. volta (dias)</mat-label>
                            <input matInput type="number" value="Per. volta (dias)" class="form-control"
                                id="qtdDiasPeriodoVolta" trim="blur" name="qtdDiasPeriodoVolta"
                                formControlName="qtdDiasPeriodoVolta">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-6">
                            <mat-label>Qtd. atend. mês</mat-label>
                            <input matInput type="number" value="Qtd. atend. mês" class="form-control" id="qtdAtdMes"
                                trim="blur" name="qtdAtdMes" formControlName="qtdAtdMes">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-6 col-md-6 col-sm-12 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="atdOutroMedicoPerVolta" formControlName="atdOutroMedicoPerVolta">
                                Atd. outro médico no período de volta?
                            </mat-checkbox>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-6 col-md-6 col-sm-12 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="indCobrarProcConsulta" formControlName="indCobrarProcConsulta">
                                Cobrar Procedimentos/Consultas?
                            </mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Observação (Exames)</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="observacao"
                                name="observacao" id="observacao" maxlength="300" upperCase></textarea>
                        </mat-form-field>

                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Observação (Consultas)</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="observacaoConsulta"
                                name="observacaoConsulta" id="observacaoConsulta" maxlength="300" upperCase></textarea>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioPlanoSaude.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>